<template>
  <div class="caption grey--text text--darken-1 pt-0 pb-3">
    Posted in <categories-list :categories="page.categories" /> and tagged
    <tags-list :tags="page.tags" /> on {{ page.date | formatDate }} by
    <router-link :to="`/author/${page.author.slug}`" v-html="page.author.name" />
  </div>
</template>
<script>
  import TagsList from './TagsList.vue'
  import CategoriesList from './CategoriesList.vue'

  export default {
    name: 'PostDetails',
    components: {
      TagsList,
      CategoriesList
    },
    props: [
      'page'
    ]
  }
</script>


// WEBPACK FOOTER //
// src/components/PostDetails.vue